module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.home.label !== undefined) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Nombre",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.label),
      callback: function($$v) {
        _vm.$set(_vm.home, "label", $$v)
      },
      expression: "home.label"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Direccion",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.address_line1),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "address_line1", $$v)
      },
      expression: "home.address.address_line1"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Datos adicionales",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.address_line2),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "address_line2", $$v)
      },
      expression: "home.address.address_line2"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Ciudad",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.city),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "city", $$v)
      },
      expression: "home.address.city"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "Provincia",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.state),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "state", $$v)
      },
      expression: "home.address.state"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input', {
    attrs: {
      "type": "text",
      "label": "País",
      "disabled": !_vm.editable
    },
    model: {
      value: (_vm.home.address.country),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "country", $$v)
      },
      expression: "home.address.country"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('fg-input-validate', {
    attrs: {
      "type": "text",
      "validations": "numeric",
      "name": "codigo postal",
      "label": "Código Postal",
      "delay": "0"
    },
    on: {
      "input-changed": _vm.input_changed
    },
    model: {
      value: (_vm.home.address.postal_code),
      callback: function($$v) {
        _vm.$set(_vm.home.address, "postal_code", $$v)
      },
      expression: "home.address.postal_code"
    }
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7fb0a3d6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/MagentaAddressForm.vue
// module id = 252
// module chunks = 3